import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export default {
  __name: 'FranchiseeTag',
  props: {
    id: {
      type: [Number, String],
      required: true
    },
    name: {
      type: String,
      default: ''
    },
    closable: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: 'default'
    }
  },
  emits: ['close'],
  setup(__props, {
    emit: __emit
  }) {
    const $props = __props;
    const $emits = __emit;
    const onClose = () => {
      $emits('close', $props.id);
    };
    return (_ctx, _cache) => {
      const _component_el_tag = _resolveComponent("el-tag");
      return _openBlock(), _createBlock(_component_el_tag, {
        closable: __props.closable,
        size: __props.size,
        onClose: onClose
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.name || __props.id), 1)]),
        _: 1
      }, 8, ["closable", "size"]);
    };
  }
};